<template>
  <div>
    <a-timeline>
      <a-timeline-item v-for="item in list" :key="item.id">
        <h3>
          <a-button type="link" style="float:right;margin-top:-6px;" @click="displayHistory(item.id)">
            <a-icon type="history" /> 历史版本
          </a-button>
          <router-link :to="'/design/'+item.id">订单 {{item.orderId}}</router-link>
          <span class="info-text ml15" v-if="item.editTime"> 上次编辑 {{item.editTime}}</span>

        </h3>
        <a-list
          item-layout="horizontal"
          class="timeline-images"
          :grid="{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 6, xxl: 6 }"
          :data-source="item.imgs"
        >
          <a-list-item slot="renderItem" slot-scope="pic" @click="$router.push('/design/'+item.id)">
            <a-card cover="">
              <img
              slot="cover"
              :src="pic"
            />
            </a-card>
          </a-list-item>
        </a-list>

      </a-timeline-item>
    </a-timeline>

    <!-- 显示历史版本 -->
    <a-drawer
      :title="`订单设计 ${history.orderId} 历史版本`"
      :width="780"
      :visible="drawVisible"
      :body-style="{ paddingBottom: '80px' }"
      @close="drawVisible=false"
    >
      <a-timeline>
        <a-timeline-item v-for="(his, index) in history.list" :key="his.id">
          <p><span style="float:right;" v-if="index==0">当前版本</span>
            <a-popconfirm v-else
              ok-text="确定"
              cancel-text="取消"
              @confirm="revertVersion(history.projectId, his.id)"
            >
              <p slot="title" style="word-break:keep-all">确定恢复到该版本吗?</p>
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a-button type="link" style="float:right;margin-top:-6px;">恢复</a-button>
            </a-popconfirm>
            <b>{{his.username}}</b>
            <span class="info-text ml15">保存时间 : {{his.updatedTime}}</span></p>
          <a-list item-layout="horizontal"
            class="timeline-images"
            :grid="{ gutter: 16, xs: 1, sm: 2, md: 2, lg: 3, xl: 3, xxl: 3 }"
            :data-source="his.imgs"
            >
            <a-list-item slot="renderItem" slot-scope="img">
              <a-card cover="">
                <img
                slot="cover"
                :src="img"
              />
              </a-card>
            </a-list-item>
          </a-list>
        </a-timeline-item>
      </a-timeline>
    </a-drawer>

  </div>
</template>

<script>
import projectModel from '@/api/project'
export default {
  components: {

  },
  props: ['list'],
  data () {
    return {
      drawVisible: false,
      history: {
        orderId: '',
        list: [
          {
            id: '',
            username: '',
            updated_time: '',
            imgs: []
          }
        ]
      },
      historyLoading: false
    }
  },
  methods: {
    async displayHistory (id) {
      this.drawVisible = true
      this.historyLoading = true
      this.history = {}
      try {
        const res = await projectModel.histories(id)
        this.history = res.data
      } finally {
        this.historyLoading = false
      }
    },
    async revertVersion (projectId, hisId) {
      this.historyLoading = true
      const self = this
      try {
        await projectModel.revertVersion(projectId, hisId)
        this.$confirm({
          title: '完成',
          content: '已恢复至该版本. 是否打开查看?',
          onOk () {
            self.$router.push('/design/' + projectId)
          },
          onCancel () {}
        })
      } finally {
        this.historyLoading = false
      }
    }
  }
}
</script>

<style>
.info-text{color:#696969;font-weight:normal;}
.ml15{margin-left:15px;}
</style>



// WEBPACK FOOTER //
// src/pages/home/List.vue